import { Dropdown, Input, message } from "antd";
import { ConditionalRenderer } from "components";
import {
  Cancel,
  CancelSelectedFile,
  Done,
  FileCancelIcon,
  ThreeDotIconBlack,
} from "icons";
import { useEffect, useRef, useState } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { CaseCard } from "../case-card";
import { ConfirmationPopUp } from "pages/cases-detail/components/modals";
import { UseLazyApiCallV2 } from "hooks";
import { TickIcon } from "pages/settings/icons";
import { CrossIcon } from "icons/crossIcon";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const DropableColumn = ({
  column,
  styles,
  tickets,
  handleUpdateStatus,
  updateOptions,
  setColumnName,
  columnId,
  handleOpenModal,
  setTicketData,
  finalEmployees,
  refetchCases,
  refetchStatuses,
  setData,
  columnName,
  dragHandleProps,
}) => {
  const [editColumnName, setEditColumnName] = useState();
  const inputNameRef = useRef();
  const { translator } = useLanguageTranslator();
  const statusColumnsTrans = translator("caseStatusColumns");

  const [openDeleteColumnPopup, setOpenDeleteColumnPopup] = useState(false);
  const [
    deleteColumn,
    {
      data: deleteColumnData,
      isLoading: deleteColumnLoading,
      error: deleteColumnErr,
    },
  ] = UseLazyApiCallV2({
    url: "/delete_status",
    method: "POST",
  });
  const [
    editColumn,
    {
      data: editColumnData,
      isLoading: editColumnLoading,
      error: editColumnErr,
    },
  ] = UseLazyApiCallV2({
    url: "/update_setting_status",
    method: "POST",
  });

  const [showEditColumnName, setShowEditColumnName] = useState({
    open: false,
    value: "",
  });

  useEffect(() => {
    if (showEditColumnName.open && inputNameRef.current) {
      inputNameRef.current.focus();
    }
  }, [showEditColumnName]);

  useEffect(() => {
    setShowEditColumnName((prev) => ({ ...prev, value: columnId }));
  }, [showEditColumnName.open]);

  function closeDeleteColumnPopup() {
    setOpenDeleteColumnPopup(false);
  }
  const moveColumn = ({ direction, columnId }) => {
    setData((prev) => {
      const newOrder = [...prev.columnOrder];
      const index = newOrder.indexOf(columnId);

      if (index === -1) return prev;

      const targetIndex = direction === "left" ? index - 1 : index + 1;

      // prevent overflow
      if (targetIndex < 0 || targetIndex >= newOrder.length) {
        return prev;
      }

      // swap
      [newOrder[index], newOrder[targetIndex]] = [
        newOrder[targetIndex],
        newOrder[index],
      ];

      return {
        ...prev,
        columnOrder: newOrder,
      };
    });
  };

  function handleClickUpdateColumn({ key, columnId }) {
    if (key === "left" || key === "right")
      moveColumn({
        direction: key,
        columnId: columnId,
      });
    else if (key === "delete") {
      setOpenDeleteColumnPopup(true);
    } else if (key === "rename") {
      setShowEditColumnName((prev) => ({ ...prev, open: true }));
    }
  }

  async function handleDeleteColumn(column) {
    try {
      const res = await deleteColumn({
        params: {
          id: column?.settingId,
        },
      });
      if (res?.status === "Success") {
        setOpenDeleteColumnPopup(false);
        const existing = JSON.parse(localStorage.getItem("statusColumnsOrder"));

        const newOnes = existing.filter((item) => item !== column.title);
        localStorage.setItem("statusColumnsOrder", JSON.stringify(newOnes));

        await refetchStatuses();
        refetchCases();
      } else {
        message.error(res?.message);
      }
    } catch (error) {
      console.log({ error });
    }
  }

  async function handleUpdateColumn({ id, statusName, isHidden }) {
    try {
      const res = await editColumn({
        params: {
          id,
          statusName,
          isHidden,
        },
      });
      if (res?.status === "Success") {
        message.success("Name Updated Successfully");
        const existing = JSON.parse(localStorage.getItem("statusColumnsOrder"));
        const index = existing.indexOf(column?.title);

        if (index !== -1) {
          existing[index] = statusName;
        }

        const newOnes = [...existing];

        localStorage.setItem("statusColumnsOrder", JSON.stringify(newOnes));

        setShowEditColumnName({ open: false, value: "" });
        await refetchCases();
        await refetchStatuses();
      }
      if (res?.status === "Error") {
        message.error(res?.message);
      }
    } catch (error) {
      message.error("Something went wrong");
    }
  }

  return (
    <>
      <Droppable
        key={column?.id}
        droppableId={column?.settingId}
        statusName={column?.id}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={styles.ticketsCol}
          >
            <div
              className={styles.header}
              {...dragHandleProps}
              style={{ borderBottom: `3px solid ${column?.color}` }}
            >
              <div className={styles.details}>
                <span
                  className={styles.circle}
                  style={{ backgroundColor: column?.color }}
                ></span>
                <ConditionalRenderer condition={!showEditColumnName.open}>
                  <h3 style={{ padding: "8px" }}>
                    {/* {
                            translator("casesTable.tableColumnsLabel")?.[
                              column.id
                            ]
                          } */}
                    {column?.id}
                  </h3>
                </ConditionalRenderer>
                <ConditionalRenderer condition={showEditColumnName.open}>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleUpdateColumn({
                        id: column?.settingId,
                        statusName: showEditColumnName.value,
                        isHidden: false,
                      });
                    }}
                  >
                    <div className={styles.editColumnField}>
                      <Input
                        required
                        value={showEditColumnName.value}
                        onChange={(e) =>
                          setShowEditColumnName((prev) => ({
                            ...prev,
                            value: e.target.value,
                          }))
                        }
                        defaultValue={column?.id}
                        ref={inputNameRef}
                      />
                      <div className={styles.actionsBtns}>
                        <button type="submit" className={styles.actionBtn}>
                          <Done />
                        </button>
                        <div
                          className={styles.actionBtn}
                          onClick={() =>
                            setShowEditColumnName((prev) => ({
                              value: columnId,
                              open: false,
                            }))
                          }
                        >
                          <Cancel />
                        </div>
                      </div>
                    </div>
                  </form>
                </ConditionalRenderer>

                <span
                  className={styles.count}
                  style={{ backgroundColor: `${column?.color}` }}
                >
                  {tickets?.length}
                </span>
              </div>
              <Dropdown
                trigger={["click"]}
                menu={{
                  items: updateOptions,
                  onClick: ({ key }) => {
                    setColumnName(column?.title);
                    handleClickUpdateColumn({ key, columnId });
                  },
                }}
              >
                <div className={styles.ThreeDotIcon}>
                  <ThreeDotIconBlack />
                </div>
              </Dropdown>
            </div>
            <div className={styles.ticketsContainer}>
              {tickets?.map((ticket, index) => {
                return (
                  <Draggable
                    key={ticket?.caseId}
                    draggableId={ticket?.caseId}
                    index={index}
                    statusId={column?.settingId}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                        }}
                        className={styles.ticketWrapper}
                      >
                        <CaseCard
                          ticketData={ticket}
                          handleUpdateStatus={handleUpdateStatus}
                          handleOpenModal={handleOpenModal}
                          setTicketData={setTicketData}
                          employees={finalEmployees}
                          refetchCases={refetchCases}
                        />
                      </div>
                    )}
                  </Draggable>
                );
              })}
            </div>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <ConfirmationPopUp
        onConfirm={() => handleDeleteColumn(column)}
        // Icon={CreateNewCaseRed}
        onClose={closeDeleteColumnPopup}
        open={openDeleteColumnPopup}
        title={statusColumnsTrans.delete}
        description={`${statusColumnsTrans.deleteConfirm} “${columnName}” ?`}
        // loading={createNewCaseLoading}
      />
    </>
  );
};
